let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hfUJY")).then(() => parcelRequire('1bJIp'));